import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { Translation } from '@/hoslog-intl';
import { EditIcon } from '@/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/store-information/premium-stores/add-premium-store')({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: (
        <CrumbTitle
          title="Manage Store Information"
          id="storeManagement.premiumStores.manageStoreInformation.crumb"
          icon={EditIcon}
        />
      ),
      title: <Translation id="storeManagement.premiumStores.manageStoreInformation.pageTitle" />,
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
